import React from 'react';
import PropTypes from 'prop-types';
import {  PageNavigation, Content } from 'core/layouts';
import { defaultTemplate } from 'core/hoc';

const PageLayoutTemplate = function ({
    title,
    children,
    emptyRenderer,
    className,
    navigationItem
}) {
    return (
        <Content emptyRenderer={emptyRenderer} >
            <div className={className ? className : 'container'}>

                {/*TODO: insert page header?*/}
                <PageNavigation title={title}>{navigationItem}</PageNavigation>

                {/* TODO: give parent route name? */}
                
                {children}
            </div>
        </Content>
    );
};

PageLayoutTemplate.propTypes = {
   store: PropTypes.any,
   title: PropTypes.string,
   children: PropTypes.any,
   emptyRenderer: PropTypes.any,
   t: PropTypes.func,
   className: PropTypes.any,
   navigationItem: PropTypes.any
};

export default defaultTemplate(PageLayoutTemplate);
